/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How multiple criteria combine within a streak window
 * @export
 */
export const StreakCriteriaOperator = {
    AND: 'AND',
    OR: 'OR'
} as const;
export type StreakCriteriaOperator = typeof StreakCriteriaOperator[keyof typeof StreakCriteriaOperator];


export function instanceOfStreakCriteriaOperator(value: any): boolean {
    for (const key in StreakCriteriaOperator) {
        if (Object.prototype.hasOwnProperty.call(StreakCriteriaOperator, key)) {
            if (StreakCriteriaOperator[key as keyof typeof StreakCriteriaOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakCriteriaOperatorFromJSON(json: any): StreakCriteriaOperator {
    return StreakCriteriaOperatorFromJSONTyped(json, false);
}

export function StreakCriteriaOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakCriteriaOperator {
    return json as StreakCriteriaOperator;
}

export function StreakCriteriaOperatorToJSON(value?: StreakCriteriaOperator | null): any {
    return value as any;
}

export function StreakCriteriaOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakCriteriaOperator {
    return value as StreakCriteriaOperator;
}

